const ErrorsMap: Record<string, string> = {
	'must NOT have more than 190 characters': 'Must be 190 characters or less',
	'must NOT have more than 400 characters': 'Must be 400 characters or less',
	'must NOT have more than 4000 characters': 'Must be 4000 characters or less',
	'Default localized info must have a title display unlimited': 'Field required on default localized info',
};

export default ErrorsMap;
